<div>
  <form nz-form [nzLayout]="'inline'" [formGroup]="apiForm" (ngSubmit)="submitForm()">
    <nz-form-item>
      <nz-form-label>API</nz-form-label>
      <nz-form-control nzErrorTip="Enter the api!">
        <nz-select class="nzSelectionSection" nzShowSearch nzAllowClear nzPlaceHolder="Select an API" formControlName="api" style="width: 100%;min-width: 350px;">
          <nz-option *ngFor="let 'api' of apiLookupDataList" [nzLabel]="api?.lookupValue" [nzValue]="api?.lookupKey"></nz-option>
          <!-- <nz-option *ngFor="let 'api' of APIRequestLookup" [nzLabel]="api?.lookupValue" [nzValue]="api?.lookupKey"></nz-option> -->
        </nz-select>
        <input hidden="true"nz-input formControlName="api" placeholder="API url" />
      </nz-form-control>
    </nz-form-item>
    <!-- <nz-form-item>
      <nz-form-label>Argument</nz-form-label>
      <nz-form-control nzErrorTip="Please enter your argument">
        <input nz-input formControlName="argument" placeholder="Enter argument" />
      </nz-form-control>
    </nz-form-item> -->
    <nz-form-item>
      <nz-form-control>
        <button nz-button nzType="primary" (click)="fetchMail()">Submit</button>
      </nz-form-control>
    </nz-form-item>
  </form>
  <button class="m-10" nz-button nzType="primary" (click)="parseJson()">Parse</button>
</div>
<div class="response-argument-space flexie-auto-grid">
  <div>
    <h1>INPUT</h1>
    <!-- <a nz-button [nzSize]="size" nzType="link" (click)="transformJson('INPUT')">Tree</a> -->
    <textarea rows="30" nz-input [(ngModel)]="argumentValue"></textarea>
  </div>
  <div>
    <h1>OUTPUT</h1>
    <!-- <a nz-button [nzSize]="size" nzType="link" (click)="transformJson('OUTPUT')">Tree</a> -->
    <textarea rows="30" nz-input [(ngModel)]="intimationNum"></textarea>
    <!-- {{apiResult | json}} -->
  </div>
</div>
